import { inject, injectable } from 'inversify';
import { firstValueFrom, take } from 'rxjs';

import { ApiConfig } from './api-config';
import { LightHttp } from './light-http.service';
import { SettingsService } from './settings.service';
import { WebSocketService } from './websocket.service';

@injectable()
export class ProcessCompleteCheckService {
    private endpointPostfix = '/workflows/process-complete-data/';

    constructor(
        @inject(LightHttp) private http: LightHttp,
        @inject(ApiConfig) private apiConfig: ApiConfig,
        @inject(WebSocketService) private wsService: WebSocketService,
        @inject(SettingsService) private settingsService: SettingsService,
    ) {

    }

    async requestToSendFileCompleteDataThroughWS(domain: string, uuid: string): Promise<any> {
        const ff = await firstValueFrom(this.settingsService.featureFlags.pipe(take(1)));
        const base = ff?.useTaskScheduling
            ? `${this.apiConfig.podEndpoint}${ApiConfig.edgePathPrefix}`
            : ApiConfig.suffixDomainWithHttpsEdgeEndpoint(domain);
        const url = `${base}${this.endpointPostfix}${uuid}/${this.wsService.getId()}`;
        return new Promise((resolve, reject) => {
            this.http.get(url).subscribe({
                next: (data: any) => {
                    if (data && data.error === false) {
                        resolve({
                            state: 'success',
                            data: data,
                        });
                    } else if (data && data.error === true) {
                        resolve({
                            state: 'error',
                            data: data,
                        });
                    } else {
                        resolve({
                            state: 'unknown',
                            data: data,
                        });
                    }
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }
}
